import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-107bf766")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "button-tip button-line",
    style: { color: _ctx.color, 'border-color': _ctx.color, width: _ctx.width }
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
})